import * as $ from 'jquery';

export default (function () {
  $('.search-toggle').on('click', e => {
    $('.search-input div.easy-autocomplete').css('width', 'auto');
    $('.search-box, .search-input').toggleClass('active');
    $('.search-input input').focus();
    e.preventDefault();
  });
}());
